import React,{Component, Fragment} from "react";
import "./TopAmbassadors.scss";
import AmbassadorHelper from "../../utils/AmbassadorHelper";
import Dotdotdot from "react-dotdotdot";
import axios from "axios";
import CheckboxBlankCircleIcon from "mdi-react/CheckboxBlankCircleIcon";

class TopAmbassadors extends Component{
    state={
        hasData: false,
        ambassadors: null
    }
    getTopAmbassadorsJson = () => {
        const fileUrl = `${TVSite.dependency_root}users_recent_8.json`
        axios({method: "get",
            url: fileUrl
        }).then(res=>{
            const {data} = res;
            if(data && data.Users && data.Users.length > 0){
                const dummies = this.validateAmbassadors(data.Users.length);
                this.setState({
                    ambassadors: {"Users": [...data.Users, ...dummies]},
                    hasData: true
                });
            }

        }).catch(er=>{
            console.log(er);
        });
    }
    componentDidMount() {
        // this.getTopAmbassadorsJson();
    }
    createDummies(dummiesQty) {
        const dummies = [];
        for (let i = 0; i < dummiesQty; i++) {
            dummies.push({
                dummy: true
            });
        }
        return dummies;
    }

    validateAmbassadors(ambassadorsQty) {
        //maybe use this function when resize for mobile
        //perPage value minus the total of products to inject the empty squares
        const perPage = 8;
        if (ambassadorsQty <= perPage) {
            return this.createDummies(perPage - ambassadorsQty);
        } else {
            const difference = ambassadorsQty / perPage;
            const oneBelow = parseInt(difference) * perPage;
            const result = ambassadorsQty - oneBelow;
            if (result !== 0)
                return this.createDummies(perPage - result);
            else
                return [];
        }

    }
    render(){
        const {hasData, ambassadors} = this.state;
        const {title} = this.props;
        return <div className={"container top-ambassador"}>
            { hasData && <Fragment>
            <div className={"row"}>
                <h2 className={"col col-12 text-center top-ambassador-title"}>{title}</h2>
            </div>
            <div className={"row"}>
                {ambassadors.Users.map((ambassador, index)=>{
                        const {dummy} = ambassador;
                        const Type =  dummy ? "div" : "a";
                        return <div key={index} className={"col-6 col-sm-3"}>
                            <Type href={TVSite.sub_folder+"/a/"+ambassador.user_slug+"/"+ambassador.user_id}>
                                <div className={"top-ambassador-item"}>
                                    <div className="embed-responsive1 embed-responsive-1by11">
                                        { ambassador.dummy ? <CheckboxBlankCircleIcon className={"top-ambassador-image-dummy"} color={"#F2F2F2"} /> : <Fragment>
                                            <img alt="test" className="top-ambassador-image" src={AmbassadorHelper.validateProfileUrl(AmbassadorHelper.getAmbassadorPhotoFromApi(ambassador))} />
                                        </Fragment>
                                        }
                                    </div>
                                    <div className={"top-ambassador-display-name text-center"}>
                                        {
                                            ambassador.dummy ? <div className={"top-ambassador-display-name-dummy"}> </div> :
                                            <Dotdotdot clamp={2}>
                                                {ambassador.storefront_details.display_name}
                                            </Dotdotdot>
                                        }
                                    </div>
                                </div>
                            </Type>
                        </div>
                    })
                }
            </div>
            </Fragment>}
        </div>
    }
}

TopAmbassadors.defaultProps = {
    title: "SHOP WITH US",
    env: TVSite.phpEnvName
}

export default TopAmbassadors;
